module.exports = __webpack_public_path__ + "static/media/usina-prd.b745ef16.jpeg";